export enum Browser {
  uc_news = 'uc_news',
  uc_browser = 'uc_browser',
  uc_mini = 'uc_mini',
  not_uc_client = 'not_uc_client',
}

// 原正文页用的Client名称
export enum Client {
  uc_news = 'app',
  uc_browser = 'ucbrowser',
  uc_mini = 'ucbrowser',
  not_uc_client = 'other',
}

export enum PlatformOS {
  ios = 'ios',
  android = 'android',
  other = 'other',
}

export const LANG_COUNTRY_DEFAULT = 'en-en';

export enum Language {
  default = 'en',
  am= 'am',
  ar= 'ar',
  be= 'be',
  bn= 'bn',
  en= 'en',
  es= 'es',
  fa= 'fa',
  fr= 'fr',
  kk= 'kk',
  ky= 'ky',
  ms= 'ms',
  my= 'my',
  ne= 'ne',
  nl= 'nl',
  pt= 'pt',
  ru= 'ru',
  si= 'si',
  sw= 'sw',
  th= 'th',
  uk= 'uk',
  ur= 'ur',
  uz= 'uz',
  vi= 'vi',
  zh= 'zh',
}

export let rtlLang = [
  Language.ar,
  Language.ur,
];

export enum Country {
  default = 'en',
  ae= 'ae',
  bd= 'bd',
  br= 'br',
  by= 'by',
  cn= 'cn',
  dz= 'dz',
  eg= 'eg',
  en= 'en', // 通英国家
  et= 'et',
  fr= 'fr',
  gb= 'gb',
  gh= 'gh',
  ir= 'ir',
  ke= 'ke',
  kg= 'kg',
  kw= 'kw',
  kz= 'kz',
  lk= 'lk',
  mm= 'mm',
  mx= 'mx',
  my= 'my',
  ng= 'ng',
  nl= 'nl',
  np= 'np',
  ph= 'ph',
  pk= 'pk',
  qa= 'qa',
  ru= 'ru',
  sa= 'sa',
  sd= 'sd',
  sg= 'sg',
  sy= 'sy',
  th= 'th',
  tz= 'tz',
  ua= 'ua',
  us= 'us',
  uz= 'uz',
  vn= 'vn',
  za= 'za',
}

export let specialLocaleMap = {
  'ar-sa': 'ar_sa',
  'zh-tw': 'zh_tw',
};

export let i18nFileNames = [
  'en',
  'ar-sa',
  'br',
  'hi',
  'ms',
  'pt',
  'th',
  'vi',
  'ar',
  'id',
  'ne',
  'ru',
  'uk',
  'zh-tw',
  'bd',
  'es',
  'kk',
  'pk',
  'si',
  'uz',
];

export enum App {
  app_iflow = 'app_iflow',
  browswer_iflow = 'browswer_iflow',
  browser_oa_profile = 'browser_oa_profile',
  app_oa_profile = 'app_oa_profile',
  other = '',
}

/** 正文页content_type定义
 * 文档 http://doc.ucweb.local/pages/viewpage.action?pageId=265231250
 */
export enum CONTENT_TYPE {
  STORY = 0, // 图文普通正文页
  IMAGE_SET = 1,  // 图集
  OPERTATION = 3,  // 投票或运营专题
  VIDEO = 4, // 视频
  SEARCH_WEMEDIA = 5, // 搜索结果自媒体订阅页
  TOPIC = 6, // 评论热门话题
  LIVE = 7, // 视频直播
  SHORT_STORY = 8, // 短内容（微博）
  QUESTION = 9, // 问答
}

export enum COMMENT_TYPE {
  TEXT = 0, // 普通评论
  IMAGE = 1,  // 图文评论
}
